import { render, staticRenderFns } from "./VisitorNoQR.vue?vue&type=template&id=1496d70a&scoped=true&"
import script from "./VisitorNoQR.vue?vue&type=script&lang=js&"
export * from "./VisitorNoQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1496d70a",
  null
  
)

export default component.exports